export enum DescriptorType {
  STRING = 'string',
  ARRAY = 'array',
  OBJECT = 'object',
}

interface BaseDescriptor {
  title?: string
  description?: string
  index?: number
}

export interface StringDescriptor extends BaseDescriptor {
  type: DescriptorType.STRING
  enum?: string[]
}

export interface ArrayDescriptor extends BaseDescriptor {
  type: DescriptorType.ARRAY
  items: Descriptor
}

export interface UiSchemaDescriptor {
  'ui:widget': string
}

export interface ObjectDescriptor extends BaseDescriptor {
  type: DescriptorType.OBJECT
  properties: Record<string, Descriptor>
  required?: string[]
  customWidgets?: Record<string, UiSchemaDescriptor>
}

export type Descriptor = StringDescriptor | ArrayDescriptor | ObjectDescriptor

export type Scorecard = {
  id: string
  scorecardPresetId?: string
  createdAt: string
  updatedAt: string
  descriptor: ObjectDescriptor
  description: string
  name: string
  type: string
  aiFeatureIds: string[]
  tags: string[]
  systemPreset: boolean
  config: ScorecardConfig
  metadata?: string
  isManagedByEnterprise: boolean
}

export type ScorecardConfig = {
  userLevel: boolean
  includeAdditionalSources: boolean
  includeInCreateClientProfile: boolean
}

export type ScorecardResult = {
  id: string
  scorecardId: string
  userId: string
  createdAt: string
  result: { [key: string]: any }
  source: { [key: string]: any }
  changes: { [key: string]: any }
  resultMetadata: { [key: string]: any }
  revision: number
}

export type ScorecardResultCreate = {
  scorecardId: string
  userId: string
  result: { [key: string]: any }
  source: { [key: string]: any }
  previousRevision: number
}

export enum ScorecardType {
  CLIENT_PROFILE = 'clientProfile',
  FORM = 'form',
}
